import { render, staticRenderFns } from "./Sidenav.vue?vue&type=template&id=0a4663dc&scoped=true&"
import script from "./Sidenav.vue?vue&type=script&lang=js&"
export * from "./Sidenav.vue?vue&type=script&lang=js&"
import style0 from "./Sidenav.vue?vue&type=style&index=0&id=0a4663dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4663dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VNavigationDrawer,VSkeletonLoader})
